import { Box, Switch, Typography } from '@mui/material';
import { useId } from 'react';
import DESIGN_COLORS from 'shared/_ui/design-colors';

type SettingRowProps = {
	title: string;
	subtitle?: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
};

/** Settings row of the new design: title + description on the left, switch on the right. */
export default function SettingRow({
	title,
	subtitle,
	checked,
	onChange,
	disabled,
}: SettingRowProps) {
	const titleId = useId();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 3,
				py: 2.5,
				borderTop: `1px solid ${DESIGN_COLORS.borderSoft}`,
				'&:first-of-type': { borderTop: 'none' },
			}}
		>
			<Box>
				<Typography id={titleId} sx={{ fontSize: 13.5, fontWeight: 600 }}>
					{title}
				</Typography>
				{subtitle && (
					<Typography sx={{ fontSize: 12, color: DESIGN_COLORS.muted }}>{subtitle}</Typography>
				)}
			</Box>
			<Switch
				checked={checked}
				disabled={disabled}
				onChange={(_, value) => onChange(value)}
				slotProps={{ input: { 'aria-labelledby': titleId } }}
			/>
		</Box>
	);
}
